import React, { useState, useEffect } from 'react'
import Footer from '../components/Footer';
import NavbarHeader from '../components/NavbarHeader';
import { Account } from '../components/Accounts'
import AgenticCashCrew from '../components/AgenticCashCrewForms';

function CashCrewAI() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Account>
            <NavbarHeader toggle={toggle} heading='Ca$h Crew AI' />
            <AgenticCashCrew />
            <Footer />
        </Account>
    );
}

export default CashCrewAI;